<template>
  <div class="tooltip-box">
    <div class="slot"><slot /></div>
    <div
      class="tooltip card"
    >
      <div class="info-block">
        <p class="font-weight-bold">Մասնակիցները գներ ներկայացնելիս պետք է հաշվի առնեն, որ</p>
        <ul>
          <li>Առաջարկած գինը ներառում է մասնակցի կողմից իրականցվող բոլոր ծախսերը, հարկերը, տուրքերը և վճարները, առաքման ծախսերը, եթե վերջիններս առանձին ներկայացված չեն։</li>
          <li>Ներկայացված կամ փոփոված գնային առաջարկը հաստատվում է «Մասնակցել» կոճակով։</li>
          <li>Տվյալ մասնակցի գինը տարբերելու համար այն ներկայացված է լինելու կանաչ գույնով՝ այլ մասնակիցներից առանձնացվելու, զբաղեցրած տեղը նկատելու և հիշեցնելու, թե որ չափաբաժիններին ինչ գնային առաջարկ է ներկայացվել։</li>
          <li>Գինը նվազեցվելու է առնվազն 1 դրամի չափով։</li>
          <li>Գնային առաջարկների փոփոխություն կարելի է անել թե նվազման և թե բարձրացման ուղղությամբ։</li>
          <li>Առաջին տեղ է զբաղեցնում այն մասնակիցը, որը տվյալ պահին ներկայացրած կլինի ամենացածր գինը։</li>
          <li>Ապրանքները մատակարարելիս մասնակիցը պարտավոր է խստագույնս պահպանել անժամկետ տենդերի պայմաններով և իր կողմից ներկայացվող ապրանքների համապատասխանությունը։</li>
        </ul>
        <p class="font-weight-bold mt-2">Մասնակիցը պարտավոր է խստագույնս պահպանել անժամկետ տենդերի պայմաններով և իր կողմից ներկայացվող ապրանքների համապատասխանությունը։</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.tooltip-box {
    position: relative;
    display: inline-block;
}

.slot{
    display: inline-block;
    z-index: 1;
}

.tooltip-box:hover .tooltip{
  display: block !important;
}
.tooltip {
    padding: 12px;
    text-align: left;
    opacity: 1;
    width: 550px;
    bottom: 100%;
    left: 50%;
    margin-left: -60px;
    border: 1px solid #EDEFF2;
    display: none !important;
    /* display: block !important; */
    transition: 1s;

    position: absolute;
    z-index: 10;
}
</style>
